import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag använda tolk på kunskapsprovet?";
const SHORT_ANSWER = "Nej. Tolk är inte tillåten på själva provet. Däremot kan du göra provet på flera språk; välj önskat språk vid bokning.";

export const Route = createFileRoute("/fraga/far-jag-tolk-pa-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag använda tolk på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Att tolka i realtid skulle bryta provets sekretess och tillförlitlighet. Förbered dig i stället via övningsfrågor på det språk du tänker göra provet på."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – språk och format" }}
      related={[{"to": "/fraga/behover-alla-i-ledningen-gora-provet", "label": "Behöver alla i ledningen göra kunskapsprovet?"}, {"to": "/fraga/vilka-delar-ingar-i-provet", "label": "Vilka delar ingår i kunskapsprovet?"}, {"to": "/fraga/far-jag-gora-provet-pa-engelska", "label": "Får jag göra kunskapsprovet på engelska?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag använda tolk på kunskapsprovet?" },
      { name: "description", content: "Nej. Tolk är inte tillåten på själva provet. Däremot kan du göra provet på flera språk; välj önskat språk vid bokning." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-tolk-pa-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-tolk-pa-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-tolk-pa-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag använda tolk på kunskapsprovet", url: "https://alkoholprovet.se/fraga/far-jag-tolk-pa-provet" },
      ]),
    ],
  }),
});
